// extracted by mini-css-extract-plugin
export default {"content":"x35LlF","layout":"nP280H","sidebar":"e_YBic","summary":"u5yMIx","confirmBooking":"DMIn8b"};